import * as React from "react";
import { CSSProperties } from "react";

interface LogoProps {
	style?: CSSProperties;
	isMobile?: boolean;
}

export default ({ style, isMobile }: LogoProps) => (
	<img
		src={
			isMobile
				? require("../res/blockv_icon_only_color.svg")
				: require("../res/blockv_logo_horizontal_color_text_dark.svg")
		}
		style={style}
	/>
);



// WEBPACK FOOTER //
// ./src/components/Logo.tsx